module.exports = __webpack_public_path__ + "static/media/premierepro.78b22e71.svg";